export const getChromeVersion = () => {
  let chromeVersion = "";
  try {
    chromeVersion = window.navigator.userAgent.match(/.*Chrome\/([0-9.]+)/)?.[1] || "";
  } catch (e) {
    chromeVersion = "";
  }
  return chromeVersion;
};

export const getChromeMajorVersion = () => {
  let chromeVersion = getChromeVersion();

  if (chromeVersion?.length > 0 && chromeVersion?.includes(".")) {
    chromeVersion = chromeVersion?.split(".")?.[0];
    return Number(chromeVersion);
  }

  return 0;
};
